import React from "react";
import "./AccordionSection.css";

interface AccordionSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const AccordionSection: React.FC<AccordionSectionProps> = ({
  title,
  isOpen,
  onToggle,
  children,
}) => {
  return (
    <div className="accordion-section">
      <div className="accordion-header" onClick={onToggle}>
        <h2 className="accordion-title">{title}</h2>
        <button className={`accordion-toggle ${isOpen ? "open" : "closed"}`}>
          ▼
        </button>
      </div>
      <div className={`accordion-content ${isOpen ? "open" : "closed"}`}>
        <div className="accordion-body">{children}</div>
      </div>
    </div>
  );
};

export default AccordionSection;
